import axiosTokenInstance from "services/api/backoffice";
import { PRODUCTS_PREPAID, PRODUCTS_PREPAID_ERROR } from "_models/redux/types";

// Action function
export const ActionProductPrepaid = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        const response = await axiosTokenInstance.get(
            `/api/callcenter/products/prepaid`
        );

        const { data, status } = response || {};

        dispatch({
            type: PRODUCTS_PREPAID,
            payload: data || {},
            status: status || {},
            method: "get",
        });
    } catch (e) {
        dispatch({
            type: PRODUCTS_PREPAID_ERROR,
            payload: e || {},
        });
    }
};
